import React, { Component, Fragment } from "react";
import { Card, CardContent } from "@material-ui/core";
import dataProviderFactory from "../dataProvider";
import { GET_LIST, Responsive } from "react-admin";
// import LinearProgress from "@material-ui/core/LinearProgress";
import ElasticGrid from "../components/elasticGrid";
// import InsuranceWarnings from "../components/dashboard/InsuranceWarnings";
// import MaintenanceWarnings from "../components/dashboard/MaintenanceWarnings";
import DisplacedVehiclesWarnings from "../components/dashboard/DisplacedVehiclesWarnings";
import FleetOptions from "../components/dashboard/FleetOptions";
import ToursOptions from "../components/dashboard/ToursOptions";
import RentalsOptions from "../components/dashboard/RentalsOptions";
import ReportsOptions from "../components/dashboard/ReportsOptions";
import styles from "../components/dashboard/Styles";
import moment from 'moment';
import moment_tz from 'moment-timezone';
import { canAccess } from "../rbac";
class Dashboard extends Component {
  async fetchData() {
    const dataProvider = await dataProviderFactory("rest");
    const response = await dataProvider(GET_LIST, "vehicles", {
      filter: {
        warning_data: true
      },
      pagination: {
        page: 1,
        perPage: 5
      },
      sort: { field: "licence_plate", order: "DESC" }
    });
    return response.data;
  }

  async componentDidMount() {
    moment_tz.tz.setDefault("Europe/Madrid");
    // const counters = await this.fetchData();
    // this.setState({
    //   vehiclesInsuranceTotal: counters[0].withoutInsurace,
    //   vehiclesMaintenaceTotal: counters[0].withouMaintenance
    // });
  }

  render() {
    // if (this.state === null) {
    //   return (
    //     <Card>
    //       <LinearProgress />
    //     </Card>
    //   );
    // }
    return (
      <Fragment>
        <Card style={styles.mainCardStyle}>
          <CardContent>
            <ElasticGrid>
              <div style={styles.ElasticColumn}>
                <Card>
                  <CardContent>
                    <div style={styles.flexColumn}>
                      <div style={{ marginBottom: "2em" }}>
                        <DisplacedVehiclesWarnings />
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </div>
            </ElasticGrid>
          </CardContent>

          {/* <CardContent>
                        <ElasticGrid>
                            <div style={styles.ElasticColumn}>
                                <Card>
                                    <CardContent>
                                        <Responsive
                                            xsmall={
                                                <div>
                                                    <div style={styles.flexColumn}>
                                                        <div style={{ marginBottom: '2em' }}>
                                                            <InsuranceWarnings value={this.state.vehiclesInsuranceTotal} />
                                                        </div>
                                                        <div style={styles.flex}>
                                                            <MaintenanceWarnings value={this.state.vehiclesMaintenaceTotal} />
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            small={
                                                <div style={styles.flexColumn}>
                                                    <div style={styles.singleCol}>
                                                        <InsuranceWarnings value={this.state.vehiclesInsuranceTotal} />
                                                    </div>
                                                    <div style={styles.flex}>
                                                        <MaintenanceWarnings value={this.state.vehiclesMaintenaceTotal} />
                                                    </div>
                                                </div>
                                            }
                                            medium={
                                                <div style={styles.flex}>
                                                    <div style={styles.leftCol}>
                                                        <div style={styles.flex}>
                                                            <InsuranceWarnings value={this.state.vehiclesInsuranceTotal} />
                                                        </div>
                                                    </div>
                                                    <div style={styles.rightCol}>
                                                        <div style={styles.flex}>
                                                            <MaintenanceWarnings value={this.state.vehiclesMaintenaceTotal} />
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        />
                                    </CardContent>
                                </Card>
                            </div>
                        </ElasticGrid>
                    </CardContent> */}
          <CardContent>
            <Responsive
              xsmall={
                <div>
                  <div style={styles.flexColumn}>
                    {canAccess("dashboard_rentals_card") && (
                      <div style={styles.flex}>
                        <RentalsOptions />
                      </div>
                    )}
                    {canAccess("dashboard_fleet_card") && (
                      <div style={styles.flex}>
                        <FleetOptions />
                      </div>
                    )}
                    {canAccess("dashboard_tours_card") && (
                      <div style={styles.flex}>
                        <ToursOptions />
                      </div>
                    )}
                    {canAccess("dashboard_reports_card") && (
                      <div style={styles.flex}>
                        <ReportsOptions />
                      </div>
                    )}
                  </div>
                </div>
              }
              small={
                <Fragment>
                  {canAccess("dashboard_rentals_card") && (
                    <div style={styles.flex}>
                      <RentalsOptions />
                    </div>
                  )}
                  {canAccess("dashboard_fleet_card") && (
                    <div style={styles.flex}>
                      <FleetOptions />
                    </div>
                  )}
                  {canAccess("dashboard_tours_card") && (
                    <div style={styles.flex}>
                      <ToursOptions />
                    </div>
                  )}
                  {canAccess("dashboard_reports_card") && (
                    <div style={styles.flex}>
                      <ReportsOptions />
                    </div>
                  )}
                </Fragment>
              }
              medium={
                <div style={styles.flex}>
                  {canAccess("dashboard_rentals_card") && (
                    <div style={styles.leftCol}>
                      <div style={styles.flex}>
                        <RentalsOptions />
                      </div>
                    </div>
                  )}
                  {canAccess("dashboard_fleet_card") && (
                    <div style={styles.rightCol}>
                      <div style={styles.flex}>
                        <FleetOptions />
                      </div>
                    </div>
                  )}
                  {canAccess("dashboard_tours_card") && (
                    <div style={styles.rightCol}>
                      <div style={styles.flex}>
                        <ToursOptions />
                      </div>
                    </div>
                  )}
                  {canAccess("dashboard_reports_card") && (
                    <div style={styles.rightCol}>
                      <div style={styles.flex}>
                        <ReportsOptions />
                      </div>
                    </div>
                  )}
                </div>
              }
            />
          </CardContent>
        </Card>
      </Fragment>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/dashboard/Dashboard.js